import { createLocaliseHref } from '../localiseHref.js';
import { redirect, permanentRedirect } from 'next/navigation';

function createRedirects(languageTag, strategy) {
    const localiseHref = createLocaliseHref(strategy);
    /**
     * When used in a streaming context, this will insert a meta tag to redirect the user to the target page.
     * When used in a custom app route, it will serve a 307/303 to the caller.
     *
     *  @param url the url to redirect to
     */
    const redirect$1 = (...args) => {
        args[0] = localiseHref(args[0], languageTag(), "/", false);
        redirect(...args);
    };
    /**
     * When used in a streaming context, this will insert a meta tag to redirect the user to the target page.
     * When used in a custom app route, it will serve a 308/303 to the caller.
     *
     * @param url the url to redirect to
     */
    const permanentRedirect$1 = (...args) => {
        args[0] = localiseHref(args[0], languageTag(), "/", false);
        permanentRedirect(...args);
    };
    return { redirect: redirect$1, permanentRedirect: permanentRedirect$1 };
}

export { createRedirects };
